import React from 'react';

export const StatsCardSkeleton: React.FC = () => {
  return (
    <div className="rounded-md border border-[#e8e4fb] bg-white px-2 py-3 sm:px-3 sm:py-3 md:px-4 md:py-4">
      <style>{`
        @keyframes shimmer {
          0%   { background-position: -800px 0; }
          100% { background-position:  800px 0; }
        }

        .sk {
          background: linear-gradient(90deg, #e8e3fb 25%, #d5cef5 50%, #e8e3fb 75%);
          background-size: 800px 100%;
          animation: shimmer 1.5s infinite linear;
          border-radius: 6px;
          display: block;
        }

        .stats-card-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 12px;
          margin-bottom: 12px;
        }

        .stats-card-left {
          display: flex;
          align-items: center;
          gap: 12px;
          flex: 1;
        }

        .stats-card-icon {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .stats-card-title {
          height: 20px;
          width: 120px;
          border-radius: 4px;
        }

        .stats-card-right {
          display: flex;
          gap: 8px;
          flex-direction: column;
          align-items: flex-end;
        }

        .stats-card-badge {
          height: 18px;
          width: 60px;
          border-radius: 4px;
        }

        .stats-card-stats {
          height: 18px;
          width: 80px;
          border-radius: 4px;
        }

        .stats-card-subtitle {
          height: 14px;
          width: 100%;
          margin-bottom: 12px;
          border-radius: 4px;
        }

        .stats-card-button {
          height: 36px;
          width: 170px;
          border-radius: 6px;
        }

        /* Responsive adjustments */
        @media (max-width: 640px) {
          .stats-card-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
            margin-bottom: 10px;
          }

          .stats-card-right {
            flex-direction: row;
            align-items: center;
            width: 100%;
          }

          .stats-card-badge,
          .stats-card-stats {
            width: 45px;
            height: 16px;
          }

          .stats-card-title {
            width: 80px;
            height: 18px;
          }

          .stats-card-icon {
            width: 24px;
            height: 24px;
          }

          .stats-card-subtitle {
            height: 12px;
            margin-bottom: 10px;
          }

          .stats-card-button {
            width: 100%;
            height: 32px;
          }
        }

        @media (min-width: 641px) and (max-width: 768px) {
          .stats-card-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 11px;
            margin-bottom: 11px;
          }

          .stats-card-right {
            flex-direction: row;
            align-items: center;
            width: 100%;
          }

          .stats-card-badge,
          .stats-card-stats {
            width: 55px;
          }

          .stats-card-title {
            width: 100px;
          }
        }

        @media (min-width: 769px) {
          .stats-card-icon {
            width: 32px;
            height: 32px;
          }

          .stats-card-title {
            width: 120px;
            height: 22px;
          }

          .stats-card-button {
            width: 170px;
            height: 38px;
          }
        }
      `}</style>

      {/* Header Row */}
      <div className="stats-card-header">
        <div className="stats-card-left">
          {/* Icon Skeleton */}
          <div className="sk stats-card-icon"></div>
          {/* Title Skeleton */}
          <div className="sk stats-card-title"></div>
        </div>

        {/* Stats/Badge Area */}
        <div className="stats-card-right">
          <div className="sk stats-card-stats"></div>
          <div className="sk stats-card-badge"></div>
        </div>
      </div>

      {/* Subtitle Skeleton */}
      <div className="sk stats-card-subtitle"></div>

      {/* Button Skeleton */}
      <div className="sk stats-card-button"></div>
    </div>
  );
};
